module.exports = __webpack_public_path__ + "static/media/livello9-logo-lettering-light.9a3015e6.svg";